"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roundNumber = exports.mathSign = exports.loadFileAsURL = exports.loadFileAsArrayBuffer = exports.getFileSizeInNearestUnit = exports.getFileMimeType = exports.getConvertedMimeTypes = exports.convertFileHeaderToMimeType = void 0;
var _constants = require("./constants");
/** Polyfill of the Math.sign */
const mathSign = input => input === 0 ? 0 : input < 0 ? -1 : 1;

/** Rounds the number into 2 decimal points */
exports.mathSign = mathSign;
const roundNumber = input => {
  const number = Number((Math.abs(input) * 100).toPrecision(15));
  return Math.round(number) / 100 * mathSign(number);
};

/** Returns the fileSize in the nearest unit */
exports.roundNumber = roundNumber;
const getFileSizeInNearestUnit = fileSize => {
  const [KByte, MByte, GByte] = [1024, Math.pow(1024, 2), Math.pow(1024, 3)];
  if (fileSize < KByte) {
    return `${fileSize}B`;
  } else if (fileSize < MByte) {
    return `${roundNumber(fileSize / KByte)}KB`;
  } else if (fileSize < GByte) {
    return `${roundNumber(fileSize / MByte)}MB`;
  } else {
    return `${roundNumber(fileSize / GByte)}GB`;
  }
};

/** Converts the fileTypes to the mime types */
exports.getFileSizeInNearestUnit = getFileSizeInNearestUnit;
const getConvertedMimeTypes = fileTypes => {
  return fileTypes.map(fileType => _constants.FILE_TYPES_TO_MIMES[fileType]);
};

/** Load the file as url */
exports.getConvertedMimeTypes = getConvertedMimeTypes;
const loadFileAsURL = file => {
  return new Promise((resolve, reject) => {
    const readerAsURL = new FileReader();
    readerAsURL.readAsDataURL(file);
    readerAsURL.onloadend = () => {
      if (readerAsURL.error) {
        reject(readerAsURL.error);
      } else {
        resolve(readerAsURL.result);
      }
    };
  });
};

/** Load the file as url */
exports.loadFileAsURL = loadFileAsURL;
const loadFileAsArrayBuffer = file => {
  return new Promise((resolve, reject) => {
    const readerAsBuffer = new FileReader();
    readerAsBuffer.readAsArrayBuffer(file);
    readerAsBuffer.onloadend = () => {
      if (readerAsBuffer.error) {
        reject(readerAsBuffer.error);
      } else {
        resolve(readerAsBuffer.result);
      }
    };
  });
};

/** Convert File Header To the Mime Type */
exports.loadFileAsArrayBuffer = loadFileAsArrayBuffer;
const convertFileHeaderToMimeType = fileHeader => {
  switch (fileHeader) {
    case "89504e47":
      return _constants.FILE_TYPES_TO_MIMES.PNG;
    case "47494638":
      return _constants.FILE_TYPES_TO_MIMES.GIF;
    case "ffd8ffe0":
    case "ffd8ffe1":
    case "ffd8ffe2":
    case "ffd8ffe3":
    case "ffd8ffe8":
      return _constants.FILE_TYPES_TO_MIMES.JPG;
    case "3c3f786d":
      return _constants.FILE_TYPES_TO_MIMES.SVG;
    default:
      return "unknown";
    // Or you can use the blob.type as fallback
  }
};

/** Get the file's mime type */
exports.convertFileHeaderToMimeType = convertFileHeaderToMimeType;
const getFileMimeType = async file => {
  const fileBuffer = await loadFileAsArrayBuffer(file);
  const fileHeaderArray = new Uint8Array(fileBuffer).subarray(0, 4);
  let fileHeader = "";
  for (let i = 0; i < fileHeaderArray.length; i++) {
    fileHeader += fileHeaderArray[i].toString(16);
  }
  return convertFileHeaderToMimeType(fileHeader);
};
exports.getFileMimeType = getFileMimeType;
//# sourceMappingURL=helpers.js.map